//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class SupportTicketModel extends ModelBase {
      static readonly $typeName = 'SupportTicketModel';
      public brieflyDescription: string;
      public browser: string;
      public dateAndTime: Date;
      public filePaths: string[];
      public key: string;
      public submittingEntities: string[];
      public url: string;
      public userEmailAddress: string;
      public username: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/security/models/SupportTicketModel.ts